import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { appLayoutRoute } from '@/app/routes/roots';
import { validateClubsSearch } from './lib/clubsSearch';

/**
 * Routes for the clubs module.
 *
 * Both pages are lazy so the module is its own chunk — the detail page pulls in
 * `Descriptions` and the edit form, neither of which the grid needs.
 *
 * The parameter is the **agency-club** id (the assignment), not the catalog
 * club id. Naming it `agencyClubId` rather than `clubId` is deliberate: both
 * ids are on every row, they are both UUIDs, and passing the wrong one produces
 * a 404 rather than anything that points at the mistake.
 */
export const clubsRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/clubs',
  component: lazyRouteComponent(() => import('./pages/ClubsListPage'), 'ClubsListPage'),
  validateSearch: validateClubsSearch,
});

export const clubDetailRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/clubs/$agencyClubId',
  component: lazyRouteComponent(() => import('./pages/ClubDetailPage'), 'ClubDetailPage'),
});

export const clubsRoutes = [clubsRoute, clubDetailRoute];
